module.exports = __webpack_public_path__ + "static/media/settings.153b4a1a.svg";